export const ENTITY_LEGAL_NOTICE_DIALOG_ID = "ENTITY_LEGAL_NOTICE_DIALOG_ID";
